export default {
  methods: {
    urlQueryBuilder (queryKeyValueObj) {
      const queryHasValue = Object.values(queryKeyValueObj)[0]
      const queryValueIsNotEmptyStringifyArray = queryHasValue !== '[]'
      const queryValueIsNotEmptyStringifyObject = queryHasValue !== '{}'
      const queryKey = Object.keys(queryKeyValueObj)[0]
      if (queryHasValue && queryValueIsNotEmptyStringifyArray && queryValueIsNotEmptyStringifyObject) {
        this.$router.push({
          query: {
            ...this.$route.query,
            ...queryKeyValueObj
          }
        }).catch(e => {}) // cath para evitar un warning erroneo https://github.com/vuejs/vue-router/issues/2872
      } else {
        const newQuery = {
          ...this.$route.query
        }
        delete newQuery[queryKey]
        this.$router.push({
          query: {
            ...newQuery
          }
        }).catch(e => {}) // cath para evitar un warning erroneo https://github.com/vuejs/vue-router/issues/2872
      }
    }
  }
}
